export default {
	canvas: null,
};
